import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2GlassEffectBackground } from 'components/mapV2/elements/MapV2GlassEffectBackground';
import { MapV2ModalLayoutPc } from 'components/mapV2/MapV2Modal/layout/generic/MapV2ModalLayoutPc';
import { MapV2ModalDetail } from 'components/mapV2/MapV2Modal/MapV2ModalDetail';
import { MapV2ModalList } from 'components/mapV2/MapV2Modal/MapV2ModalList';
import { AnimatePresence, motion, useAnimationControls } from 'framer-motion';
import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useContext, useEffect, useState } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storiesList: FFullMoment[];
    marker: WorldMapMarkerStory_worldMapView_markers | null;
}

export const MapV2WithListPc = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxMapV2 = useContext(CtxMapV2);
    const isWide = ctxMapV2.isWide;
    const controls = useAnimationControls();

    const [height, setHeight] = useState<string>('0px');

    useEffect(() => {
        if (ctxModal.detailModal?.detail) {
            controls.start({ x: -375 }, { duration: 0.3, ease: 'easeInOut' });
        } else {
            controls.start({ x: 0 }, { duration: 0.3, ease: 'easeInOut' });
        }
    }, [ctxModal.detailModal?.detail]);

    return (
        <MapV2ModalLayoutPc
            className={props.className}
            onHeightChanged={(height) => {
                setHeight(height);
            }}
        >
            <AnimatePresence mode="wait">
                <S_Over
                    $isWide={isWide}
                    initial={{ x: 0 }}
                    animate={controls}
                    exit={{ x: 0 }}
                    transition={{ duration: 0.0, ease: 'easeInOut' }}
                    layout
                >
                    {isWide && <MapV2GlassEffectBackground color="rgba(246, 247, 245, 0.7)" />}
                    <S_MapV2ModalList stories={props.storiesList} height={height} />
                    {ctxModal.detailModal?.detail && (
                        <S_MapV2ModalDetail
                            story={ctxModal.detailModal.detail}
                            marker={props.marker}
                            height={height}
                        />
                    )}
                </S_Over>
            </AnimatePresence>
        </MapV2ModalLayoutPc>
    );
};

const S_Over = styled(motion.div)<{ $isWide: boolean }>`
    display: flex;
    flex-direction: row;
    width: 750px;
`;

const S_MapV2ModalDetail = styled(MapV2ModalDetail)`
    width: 375px;
`;

const S_MapV2ModalList = styled(MapV2ModalList)`
    width: 375px;
`;
